import { render } from "./ui-sidebar-module-categories.vue?vue&type=template&id=66f976d6&scoped=true"
import script from "./ui-sidebar-module-categories.vue?vue&type=script&lang=js"
export * from "./ui-sidebar-module-categories.vue?vue&type=script&lang=js"

import "./ui-sidebar-module-categories.vue?vue&type=style&index=0&id=66f976d6&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66f976d6"]])

export default __exports__